import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { BlurScrollEffect } from '../effects/blurScrollEffect';
import { PRODUCTS } from '../data/products';

gsap.registerPlugin(ScrollTrigger);

const Shop = () => {
  const shopIntroRef = useRef(null);

  useEffect(() => {
    if (!shopIntroRef.current) return;
    new BlurScrollEffect(shopIntroRef.current);
  }, []);

  useEffect(() => {
    const items = document.querySelectorAll('.shop-page .shop-item');
    if (!items.length) return;

    const animations = Array.from(items).map((el, index) =>
      gsap.fromTo(
        el,
        { opacity: 0, y: 30, filter: 'blur(4px)' },
        {
          opacity: 1,
          y: 0,
          filter: 'blur(0px)',
          duration: 0.7,
          ease: 'power2.out',
          delay: index * 0.12,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    );

    return () => {
      animations.forEach((anim) => {
        if (anim.scrollTrigger) {
          anim.scrollTrigger.kill();
        }
        anim.kill();
      });
    };
  }, []);

  const rows = [PRODUCTS.slice(0, 3), PRODUCTS.slice(3, 6)];

  return (
    <div className="shop-page">
      <section className="section shop">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-3">
              <span className="mono">Shop</span>
            </div>

            <div className="col-2" />

            <div className="col-7">
              <p className="large light introtext" ref={shopIntroRef}>
                Small batches of high-quality clothing, products, prints and local collaborations.
              </p>
            </div>
          </div>

          {rows.map((row, rowIndex) => (
            <div className="row shop-row" key={`shop-row-${rowIndex}`}>
              {row.map((product) => (
                <div className="col-4 shop-item" key={product.code}>
                  <Link
                    to={`/shop/${product.slug}`}
                    className="shop-item__inner"
                    aria-label={`${product.code} ${product.name}`}
                  >
                    <img
                      src={product.image}
                      alt={product.alt}
                      className="shop-item__image"
                    />
                    <div className="shop-item__meta mono">
                      <span className="shop-item__code">{product.code}</span>
                      <span className="shop-item__price">{product.price}</span>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Shop;
